/**
 *
 * ControlStdPresens
 *
 */

import React, { memo, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Checkbox, Button } from 'antd';

// utils
import { getExcusedAbsenceStd, generateAbsenceReason } from 'utils/helpers/helper.generateData';
import {
  getArrayIds,
  getUniqueArrayObj,
  getObjId,
} from 'utils/helpers/helper.general';

function ControlStdPresens({
  // states
  formData,
  course,
  currentStep,
  controlType,
  // actoins
  nextStep,
  goToStep,
  result,
  // default props
  className,
}) {
  const childClassNames = classNames('control-std-presens', className);
  //const { isMobile } = useDeviceDetect();

  const [students, setStudents] = useState([]);
  const [absencesStudents, setAbsencesStudents] = useState([]);
  const [missingStudents, setMissingStudents] = useState([]);
  const [presens, setPresens] = useState([]);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    if (course?._id) {
      const stdArray = course?.students.slice() || [];
      const missingArray = formData?.missing_students.slice();
      const std = stdArray?.sort((a, b) =>
        a?.description?.lastname.localeCompare(b?.description?.lastname),
      );
      setStudents(std);

      const absStd = getExcusedAbsenceStd(std, formData?.date, course);

      setAbsencesStudents(absStd);
      setMissingStudents(missingArray);

      filteByControlType(controlType, std, missingArray, absStd);
    }
  }, [course, formData]);

  // Clearing the state after unmounting a component
  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
      setPresens([]);
      setMissingStudents([]);
      setStudents([]);
    };
  }, []);

  const filteByControlType = (type, array, missingArray = [], abs = []) => {
    switch (type) {
      case 'check-absent':
        if (Array.isArray(array)) {
          const uniqueMissing = getUniqueArrayObj(
            [...missingArray, ...abs],
            '_id',
          );
          let missStd = array?.filter(stdP => {
            const miss =
              uniqueMissing && uniqueMissing.find(std => std?._id == stdP?._id);
            return miss && stdP;
          });
          setPresens(missStd);
        }
        break;

      case 'check-present':
        if (Array.isArray(array)) {
          const uniqueMissing = getUniqueArrayObj(
            [...missingArray, ...abs],
            '_id',
          );
          let prsentsStd = array?.filter(stdP => {
            const miss =
              uniqueMissing && uniqueMissing.find(std => std?._id == stdP?._id);
            return !miss && stdP;
          });
          setPresens(prsentsStd);
        }
        break;

      case 'all':
        if (Array.isArray(array)) {
          const uniqueMissing = getUniqueArrayObj(
            [...missingArray, ...abs],
            '_id',
          );
          let prsentsStd = array?.filter(stdP => {
            const miss = abs && abs.find(std => std?._id == stdP?._id);
            return !miss && stdP;
          });
          setMissingStudents(abs);
          setPresens(prsentsStd);
        }
        break;
    }
  };

  const onFilter = useCallback(
    checkedValues => {
      if (controlType == 'check-absent') {
        const missing = students?.filter(stdP =>
          checkedValues.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setMissingStudents(missing);
        const presenseStd = students?.filter(
          stdP => !missing.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setPresens(presenseStd);
      } else if (controlType == 'check-present') {
        const presenseStd = students?.filter(stdP =>
          checkedValues.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setPresens(presenseStd);
        const missing = students?.filter(
          stdP =>
            !checkedValues.find(stdId => getObjId(stdId) == getObjId(stdP)),
        );
        setMissingStudents(missing);
      }
    },
    [controlType, students],
  );

  const onValid = useCallback(() => {
    nextStep !== undefined && nextStep();
    result({
      missing_students: missingStudents,
      students: presens,
    });
  }, [missingStudents, presens]);

  let list = controlType == 'check-absent' ? missingStudents : presens;

  const stdReason = useCallback(absData => generateAbsenceReason(absData), []);

  return (
    students && (
      <div className={childClassNames}>
        <Checkbox.Group
          className="list-present-student"
          name={`ControlStdPresens`}
          onChange={onFilter}
          value={getArrayIds(list)}
        >
          {students.map((opt, inx, arr) => {
            let showAbs;
            const disabeled =
              formData?.absences &&
              formData?.absences.filter(a => getObjId(a?.student) == getObjId(opt)) || [];
            const hasSickness = disabeled?.filter(absence => absence?.status == 'sick') || [];
            showAbs = disabeled[0];
            if (hasSickness?.length > 0) {
              showAbs = hasSickness[0];
            } 
            return (
              <Checkbox
                key={`${opt?._id}-option`}
                value={opt?._id}
                className={`item-present ${disabeled.length > 0 ? 'disabeled' : ''}`}
                disabeled={disabeled.length > 0}
              >
                <span className="item-absence-title">
                  {`${opt?.description?.lastname} ${
                    opt?.description?.firstname
                  }`}
                  {showAbs && stdReason(showAbs)}
                </span>
              </Checkbox>
            );
          })}
        </Checkbox.Group>
        <div className="control-actions-wrapper">
          <Button className="next-btn" onClick={onValid}>
            Valider
          </Button>
        </div>
      </div>
    )
  );
}

ControlStdPresens.defaultProps = {};
ControlStdPresens.propTypes = {};

export default memo(ControlStdPresens);
